import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Card, CardContent, Typography, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/Members.css';
const MembersList = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await axios.get('/api/members');
        setMembers(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching members:", error);
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  if (loading) return <CircularProgress />;

  return (
    <Box p={3}>
      {/* <Typography variant="h5" gutterBottom>
        Members List
      </Typography>
      <Grid container spacing={2}>
        {members.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member._id}>
            <Card sx={{ backgroundColor: '#fafafa', boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6">{member.name}</Typography>
                <Typography>Email: {member.email}</Typography>
                <Typography>Phone: {member.phone}</Typography>
                <Typography>Role: {member.role}</Typography>
                 <Typography>Joined: {new Date(member.createdAt).toLocaleDateString()}</Typography> 
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid> */} 
       <Box p={3}>
          
              <div className='memcontentCard'>
                  <div className='memcardHeader'>
                    <h3 className='memcardTitle'>Members Lists</h3>
                    <button style={{ backgroundColor: '#059669'}}
                    className='memprimaryButton'
                    onClick={() => navigate('/dashboard/members/addmember')}>
                      Add New Member
                    </button>
                  </div>
                  {members.map((mem) => (
                    <div key={mem._id} className="memjobCard">
                      <div className="memjobInfo">
          <h4 className="memjobTitle">{mem.name}</h4>
          <p className="memjobDetails">Email: {mem.email}</p>
          <p className="memjobDetails">Contact Number: {mem.phone}</p>
          <p className="memjobDetails">Role: {mem.role}</p>
                       
                      </div>
                      {/* <span style={styles.statusBadge}>
                        Active
                      </span> */}
                    </div>
                  ))}
                </div>
          </Box>
    </Box>
  );
};

// const styles = {

//   contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   primaryButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//     jobCard: {
//     border: '1px solid #e5e7eb',
//     borderRadius: '8px',
//     padding: '16px',
//     marginBottom: '12px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start'
//   },
//   jobInfo: {
//     flex: 1
//   },
//   jobTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   jobDetails: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: '0 0 4px 0'
//   },
//   jobMeta: {
//     fontSize: '14px',
//     color: '#9ca3af',
//     margin: 0
//   },
//   statusBadge: {
//     padding: '4px 8px',
//     backgroundColor: '#dcfce7',
//     color: '#065f46',
//     fontSize: '12px',
//     borderRadius: '9999px'
//   },
// }

export default MembersList;
